import {createEnumType} from 'acscp/api/models/customTypes/enumUtils';

export enum QuoteType {
    Standard = 'Standard',
    Series = 'Series',
    GoNow = 'GoNow',
    OBC = 'OBC',
    ACMI = 'ACMI',
}

export const QuoteTypeDynamicType = createEnumType('QuoteType', QuoteType);
